module.exports = __webpack_public_path__ + "img/9791190403887.5784a7ed.jpg";